import { Builder } from '@builder.io/sdk';
import dynamic from 'next/dynamic';

const TextImageBlock = dynamic(() => import('./TextImageBlock').then((m) => ({ default: m.TextImageBlock })));
import { BuilderInputOptions } from '@/types/builder';

const TextImageBlockConfig = {
  name: 'TextImageBlock',
  friendlyName: 'Text & Image Block',
  defaultStyles: {
    margin: '0',
  },
  canHaveChildren: true,
  inputs: [
    {
      name: 'title',
      type: 'string',
      defaultValue: 'Enter a title',
    },
    {
      name: 'isHero',
      helperText: 'Is this component a page hero?',
      type: 'boolean',
      defaultValue: false,
    },
    {
      name: 'content',
      type: 'richText',
    },
    {
      name: 'image',
      type: 'file',
    },
    {
      name: 'fill',
      friendlyName: 'Fill Image',
      type: 'boolean',
      defaultValue: false,
    },
    {
      name: 'position',
      friendlyName: 'Fill position',
      type: 'string',
      defaultValue: 'center',
      showIf: (options: BuilderInputOptions) => !!options.get('fill'),
      enum: [
        { label: 'Centre', value: 'center' },
        { label: 'Top', value: 'top' },
        { label: 'Top right', value: 'top right' },
        { label: 'Right', value: 'right' },
        { label: 'Bottom right', value: 'bottom right' },
        { label: 'Bottom', value: 'bottom' },
        { label: 'Bottom left', value: 'bottom left' },
        { label: 'Left', value: 'left' },
        { label: 'Top left', value: 'top left' },
      ],
    },
  ],
};

Builder.registerComponent(TextImageBlock, TextImageBlockConfig);
